import React from 'react';
import ICN from './pageIcons';

const BulkBar = ({ count, onArchive, onTag, onAssign, onExport, onClear }) => (
    <div className="rs-bulk">
        <b>{count}</b>
        <span>selected</span>
        <button type="button" className="ba" onClick={onAssign}>{ICN.assign}Assign</button>
        <button type="button" className="ba" onClick={onTag}>{ICN.tag}Tag</button>
        <button type="button" className="ba" onClick={onExport}>{ICN.download}Export</button>
        <button type="button" className="ba" onClick={onArchive}>{ICN.archive}Archive</button>
        <button type="button" className="ba x" onClick={onClear} aria-label="Clear">{ICN.x}</button>
    </div>
);

export default BulkBar;
